<template>
  <span class="verification-shield" :class="{ 'verification-shield--verified': verified }">
    <i :class="verified ? 'fa fa-shield-alt' : 'fa fa-shield-alt'" />
  </span>
</template>

<script>
export default {
  name: "VerificationShield",
  props: {
    verified: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.verification-shield {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 14px;
  color: #909399;
  background: rgba(255, 255, 255, 0.1);
}
.verification-shield--verified {
  color: #67c23a;
  background: rgba(103, 194, 58, 0.15);
}
</style>
